var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98231 0.737793C4.43481 0.737793 0.737305 4.43529 0.737305 8.98279C0.737305 13.5303 4.43481 17.2278 8.98231 17.2278C13.5298 17.2278 17.2273 13.5303 17.2273 8.98279C17.2273 4.43529 13.5298 0.737793 8.98231 0.737793ZM8.2007 11.7373C8.42183 11.5162 8.69343 11.3973 8.99093 11.3973C9.29706 11.3973 9.56865 11.5075 9.79843 11.7373C10.0196 11.9584 10.1384 12.23 10.1384 12.5448C10.1384 12.8509 10.0282 13.1225 9.79843 13.3609C9.58593 13.5821 9.31365 13.6923 8.99093 13.6923C8.68479 13.6923 8.42115 13.5821 8.2007 13.3523C7.97956 13.1312 7.8607 12.8596 7.8607 12.5448C7.8607 12.2387 7.97093 11.9664 8.2007 11.7373ZM9.24593 9.85863H8.7532C8.43047 9.85863 8.25183 9.66341 8.2007 9.27227L7.8182 5.2261C7.79296 4.96246 7.78433 4.78383 7.78433 4.72474C7.78433 4.18087 8.1841 3.91724 8.99956 3.91724C9.81569 3.91724 10.2148 4.18087 10.2148 4.72474C10.2148 4.8861 10.2062 5.03951 10.1896 5.2261L9.79842 9.27227C9.75592 9.66274 9.56932 9.85863 9.24593 9.85863Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.6f9391c0fb38c0213b3ac7e6c4e6b648.svg";
export { ForwardRef as ReactComponent };